<div [formGroup]="form" class="mt-1">
  <div class="form-group row">
    <label class="col-2 col-form-label">คำถาม</label>
    <div class="col-9">
      <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off" ngDefaultControl>
    </div>
  </div>

  <div class="form-group row justify-content-center">
    <label class="col-3 col-form-label">ประเภทคำถามย่อย</label>
    <div class="col-6">
      <select class="custom-select form-control" style="display: inline;" formControlName="subType"
        (change)="setSubType($event)">
        <option selected disabled hidden>เลือกประเภท</option>
        <option *ngFor="let t of subQuestionType" [value]="t.name">{{ t.name }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="subType === 'Multiple Choice'">
    <div *ngFor="let sub of multiFormArray.controls; let i = index" formArrayName="subQuestion"
      class="multiFrame pt-2 pb-2">
      <div [formGroupName]="i" class="container">
        <div class="row" style="justify-content: right;">
          <button mat-mini-fab class="img close-btn" (click)="deleteChoice(multiFormArray, i)"
            [style.backgroundImage]="'url(\' ../../../../assets/close.png\')'">
          </button>
        </div>
        <form [formGroup]="sub">
          <lifedi-question-multiple-choice [multipleChoiceForm]="sub"></lifedi-question-multiple-choice>
        </form>
      </div>
    </div>

    <div class="row justify-content-center">
      <button style="background: #005C3D; color: #fff;" (click)="addSubQuestion(multiFormArray)" mat-button>
        เพิ่มคำถาม
      </button>
    </div>
  </div>

  <div *ngIf="subType === 'Rating'">
    <div *ngFor="let sub of multiFormArray.controls; let i = index" formArrayName="subQuestion"
      class="multiFrame pt-2 pb-2">
      <div [formGroupName]="i" class="container">
        <div class="row" style="justify-content: right;">
          <button mat-mini-fab class="img close-btn" (click)="deleteChoice(multiFormArray, i)"
            [style.backgroundImage]="'url(\' ../../../../assets/close.png\')'">
          </button>
        </div>
        <form [formGroup]="sub">
          <lifedi-question-rating [ratingForm]="sub"></lifedi-question-rating>
        </form>
      </div>
    </div>

    <div class="row justify-content-center">
      <button style="background: #005C3D; color: #fff;" (click)="addSubQuestion(multiFormArray)" mat-button>
        เพิ่มคำถาม
      </button>
    </div>
  </div>

  <div *ngIf="subType === 'Ranking'">
    <div *ngFor="let sub of multiFormArray.controls; let i = index" formArrayName="subQuestion"
      class="multiFrame pt-2 pb-2">
      <div [formGroupName]="i" class="container">
        <div class="row" style="justify-content: right;">
          <button mat-mini-fab class="img close-btn" (click)="deleteChoice(multiFormArray, i)"
            [style.backgroundImage]="'url(\' ../../../../assets/close.png\')'">
          </button>
        </div>
        <form [formGroup]="sub">
          <lifedi-question-ranking [rankingForm]="sub"></lifedi-question-ranking>
        </form>
      </div>
    </div>

    <div class="row justify-content-center">
      <button style="background: #005C3D; color: #fff;" (click)="addSubQuestion(multiFormArray)" mat-button>
        เพิ่มคำถาม
      </button>
    </div>
  </div>

  <div *ngIf="subType === 'Most/Least'">
    <div *ngFor="let sub of multiFormArray.controls; let i = index" formArrayName="subQuestion"
      class="multiFrame pt-2 pb-2">
      <div [formGroupName]="i" class="container">
        <div class="row" style="justify-content: right;">
          <button mat-mini-fab class="img close-btn" (click)="deleteChoice(multiFormArray, i)"
            [style.backgroundImage]="'url(\' ../../../../assets/close.png\')'">
          </button>
        </div>
        <form [formGroup]="sub">
          <lifedi-question-most-least [mostLeastForm]="sub"></lifedi-question-most-least>
        </form>
      </div>
    </div>
    <div class="row justify-content-center">
      <button style="background: #005C3D; color: #fff;" (click)="addSubQuestion(multiFormArray)" mat-button>
        เพิ่มคำถาม
      </button>
    </div>
  </div>
</div>
